import { report } from '../_test/data/progress';
import { getProgressActivitiesForStudents } from "../../../services/API";
import {locales} from "Constants/constants";
import { generateProgressReport } from '../util/generators/generateProgressReport';
import { accountForTrendline } from '../state/progress/creators';
import {hasPendingAssessment} from '../util/pendingAssessment';
import {fetchARMScore} from '../util/getArmScore';

// TODO generate report, rename method, add scale method (or reconsider activity caching)
export const fetchActivities = (studentId, equating, locale, scale) => {
  if(locale === locales.ES_MX) equating = false; // this is the line that causes Spanish to not have equating for AE-14215
  // Fetch activities for a particular student
  return getProgressActivitiesForStudents([{id: studentId.value}],600, undefined, equating, locale, scale).then((activities) => {
    activities.map((act)=>{
      act.student.grade = studentId.grade > 6 ? 6 : studentId.grade;
    });
    return activities;
  });
}

export const fetchReport = async (student, metric, scale, benchmark, customBenchmarks, equating, locale, additionalProps={}, selectedStatePercentileCuts) => {
  try {

    const progressPromise = fetchProgressActivities(student, equating, locale, metric, scale, benchmark, customBenchmarks, selectedStatePercentileCuts);
    const progress = await progressPromise;
    const [report, activities] = progress;

    const armScorePromise = additionalProps.skipARM ? Promise.resolve(null) : fetchARMScore(student, activities);
    const pendingAssessmentPromise = hasPendingAssessment(student.value);

    const [armScore, isPending] = await Promise.all([armScorePromise, pendingAssessmentPromise]);

    report.armScore = armScore;
    report.isPending = isPending;

    return [report, activities];
  } catch (error) {
    console.error("An error occurred while fetching the report:", error);
    throw error;
  }
};

const fetchProgressActivities = (student, equating, locale, metric, scale, benchmark, customBenchmarks, selectedStatePercentileCuts) => {
  return fetchActivities(student, equating, locale, scale)
  .then(async (activities) => {
    if(!activities.student || !activities.student.grade){
      activities.map((act,index)=>activities[index].student=student);
    }
    let report = generateProgressReport(activities, metric, scale, benchmark, customBenchmarks, locale, selectedStatePercentileCuts);
    report = accountForTrendline(report, scale, student,locale);
    return [report, activities]
  })
}

export default {
  fetchActivities,
  fetchReport,
}